import { render, staticRenderFns } from "./BlockEditorSingleIconPrefix.vue?vue&type=template&id=4df5c72e"
import script from "./BlockEditorSingleIconPrefix.vue?vue&type=script&lang=js"
export * from "./BlockEditorSingleIconPrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports